import React from "react";
import { ContainerStyled } from "../../../styles/styled";

const PurchaseReturns = () => <ContainerStyled>PurchaseReturns</ContainerStyled>;

export default PurchaseReturns;
